module.exports = __webpack_public_path__ + "img/Logo_Code_for_Germany.a3c86589.svg";